import React, { useEffect, useState, useRef } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridActionsCellItem } from "@mui/x-data-grid";
import EmailIcon from "@mui/icons-material/Email";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import TaskIcon from "@mui/icons-material/Task";
import { LicenseInfo } from "@mui/x-license";

import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Button, IconButton, Select, styled, Tooltip } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import TablePagination from "@mui/material/TablePagination";

import {
  Paper,
  Box,
  Grid,
  Typography,
  responsiveFontSizes,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
} from "@mui/material";

import Divider from "@mui/material/Divider";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import axios from "../../api/axios";

import { muixlicensekey, url } from "../../configlink";
import { useSelector } from "react-redux";


const DiscountTable = () => {

  let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  const [data, setData] = useState([]);
  const [dataDuplicate, setDataDuplicate] = useState([]);

  const [query, setQuery] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [currRowPerPage, setCurrRowPerPage] = useState(50);
  const [totalRowCount, setTotalRowCount] = useState(1000);


  async function handleChangeCurrPage(event, newpage) {
    setCurrPage(newpage);
  }

  async function handleChangeRowsPerPage(event) {
    setCurrRowPerPage(parseInt(event.target.value, 10));
    setCurrPage(0);
  }


  const [search_value, setSearchValue] = useState("");

  const [statusBox, setStatusBox] = useState(-1);

  const handleStatusBoxChange = (event) => {
    setStatusBox(event.target.value)
    
    let filter

    if(event.target.value !== -1 ){
      filter = dataDuplicate.filter(x => x.status === event.target.value )
      setData(filter)
    }
    else {
      setData(dataDuplicate)
    }

  }

  useEffect(() => {
    getAllDisounts();
  }, [currPage, currRowPerPage, query]);

  const getAllDisounts = async () => {
    
    try {
      const response = await axios.get(
        `${url}/api/admin/get_discounts`,{
          params: {
            // currPage: currPage,
            // currRowPerPage: currRowPerPage,
            search: query,
          },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        },
      );

      console.log(response.data);
      
    //   setTotalRowCount(response.data.totalRow);
      setData(response.data.data);
      setDataDuplicate(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  LicenseInfo.setLicenseKey(
	muixlicensekey
  );
	
	function updateDiscountCodes(){
	
		let conf = window.confirm(`Check which of the Active WPS20_ and Referral_ codes have been used?`)
	
		if(conf){
			try {
				fetch(`${url}/api/admin/update_used_discounts`, {
					method: 'GET',
					credentials: 'include',
					headers: {
					'acgt-admin': adminUser
					},
				})
				.then(res => res.json())
				.then(data => {
					console.log(data);
				
					if(data.message === 'success'){
						let message2 = ''
						let rows = data.data
	
						rows.forEach(item => {
							message2 += `ID:${item.id} - ${item.discount_code} used for Order#: ${Number(item.OrderId)+600000} \n`
						})
	
						alert(message2)
					}
					else if(data.message === 'none'){
						alert("None of the Active ones are used yet | Everything's updated")
					}
				})
				.catch(err => {
					console.log(err);
				})
			
			} catch (error) {
				console.log(error);  
			}  
		}
	
	}
	
	
  function newDiscount (){
      const url = `/editdiscountdetails`;
      const width = 900;
      const height = 800;
  
      const left = 100
      const top = 100
  
      window.open(
        url,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
      );
  }


  function editDiscount(x){
    const url = `/editdiscountdetails?id=${x}`;
    const width = 900;
    const height = 800;

    const left = 100
    const top = 100

    window.open(
      url,
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  }

    function changeStatus(x){
          console.log(x);
          let conf = window.confirm("Change status for Discount ID:"+x+"?")
  
          if(conf){
              try {
              let y =  fetch(`${url}/api/admin/change_discount_status?id=${x}`, {
                      method: 'PUT',
                      credentials: 'include',
                      headers: {
                        'acgt-admin': adminUser
                      },
                  })
                  .then(res => res.json())
                  .then(data => {
                      if(data.message === 'success'){
                          alert("Success")
                          getAllDisounts()
                      }
                  })
                  .catch
              } catch (error) {
                  console.log(error);
              }
          }
    }


  function deleteDiscount(x){
    console.log(x);
    let conf = window.confirm("Delete Discount ID:"+x+"?")

    if(conf){
        try {
        fetch(`${url}/api/admin/delete_discount?id=${x}`, {
                method: 'DELETE',
                credentials: 'include',
            })
            .then(res => res.json())
            .then(data => {
                if(data.message === 'success'){
                    alert("Success")
                    getAllDisounts()
                }
            })
            .catch(err => {
              console.log(err);
              
            })
        } catch (error) {
            console.log(error);
        }
    }
}


  const columns = [
    {
        field: "id",
        headerName: "ID",
        type: "string",
        hide: true,
        width: 50,
    },
    {
        field: "discount_code",
        headerName: "Discount Code",
        type: "string",
        width: 230,
        editable: false,
    },
	{
		field: "discountDescription",
		headerName: "Description",
		type: "string",
		width: 160,
		editable: false,
		valueGetter: (params) => {
		const val2 = params.row.discount_value;
		const hasUpto = Number(params.row.discount_upto) > 0 ? true : false;
		const type2 = params.row.discount_type === null ? '' : params.row.discount_type === 1 ? `$${val2} `: params.row.discount_type === 3 ? `${val2} Rxn(s)`: hasUpto ? `${val2}% upto $${params.row.discount_upto}`: `${val2}%`
		
		return type2
		}
	},
    {
        field: "fromDate",
        headerName: "Valid From",
        type: "string",
        width: 150,
        editable: false,
        valueGetter: (params) => params.value ? params.value.split('T')[0] : ''
      },
      {
        field: "toDate",
        headerName: "Valid Until",
        type: "string",
        width: 150,
        editable: false,
        valueGetter: (params) => params.value ? params.value.split('T')[0] : ''
      },
    {
      field: "discount_org",
      headerName: "Organizations",
      type: "string",
		width: 280,
      editable: false,
      valueGetter: (params) => {
        if(params.value === null || params.value === ''){
          return ''
        }
        else {
          let showOrg = []
          
          let val = JSON.parse(params.value)
          // console.log(val);
          
          if(val.orgs.length > 0) {
              for(let i=0; i<val.orgs.length; i++){
                  showOrg.push(val.orgs[i].name)
              }
          }
  
          return showOrg.join(', ')

        }
      }
    },
    
     {
      field: "discount_user",
      headerName: "Users",
      type: "string",
		width: 280,
      editable: false,
      valueGetter: (params) => {
      if(params.value === null || params.value === ''){
          return ''
        }
        else {
          let showUsers = []
          
          let val = JSON.parse(params.value)
          // console.log(val);
          
          if(val.users.length > 0) {
              for(let i=0; i<val.users.length; i++){
                  showUsers.push(val.users[i].name)
              }
          }
  
          return showUsers.join(', ')

        }
      }
    },
    {
        field: "status",
        headerName: "Status",
        type: "string",
        width: 100,
        editable: false,
        valueGetter: (params) => params.value === null ? '' :params.value === 1 ? "Active": "Inactive",
        renderCell: (params) => (
          params.value === "Active" ? 
          <span className="text-green-500 font-bold">{params.value}</span>
          :
          <span className="">{params.value}</span>
        )
      },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
		(Number(id) === 1 || Number(id) === 50) ?
          <></>
          :
          <>
            <GridActionsCellItem
              icon={
                <Tooltip title='Edit'>
                  <EditIcon />
                </Tooltip>}
              onClick={() => editDiscount(id)}
              key={id}
              label="Edit"
              className="textPrimary"
            />

            <GridActionsCellItem
                        icon={
                            <Tooltip title='Change Status'>
                                <TaskIcon />
                            </Tooltip>
                        }
                        onClick={() => changeStatus(id)}
                        key={id}
                        label="status"
                        className="textPrimary"
                      />

            <GridActionsCellItem
              icon={
                  <Tooltip title='Delete'>
                      <DeleteIcon />
                  </Tooltip>
              }
              onClick={() => deleteDiscount(id)}
              key={id}
              label="delete"
              className="textPrimary"
            />
          </>
        ];
      },
    },
  ];

  return (
    <>
      <div
        style={{
          paddingTop: 20,
          padding: 30,
          paddingBottom: 10,
          width: "1650px",
        }}
      >
        <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
          <Box>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs style={{width:'100%', display:'flex', justifyContent:'space-between'}}>
                {/* any elements nested inside the role="presentation" preserve their semantics. */}
                <Typography gutterBottom variant="h6" component="div">
                  Discount Coupons
				</Typography>
				<div className="flex gap-[40px]">
					<Button variant="outlined" 
					style={{color:'white', backgroundColor:'rgb(191, 105, 0)', border:'none', textTransform: 'none', height:30, fontSize:12 }} 
					onClick={() => updateDiscountCodes()}>
						Check for Used Codes
					</Button>
					<Button variant="outlined" 
					style={{color:'white', backgroundColor:'var(--color-primary-purple)', border:'none', textTransform: 'none', height:30, fontSize:12 }} 
					onClick={() => newDiscount()}>
						Create Discount
					</Button>
				</div>
              </Grid>
            </Grid>
            <Divider component="div" role="presentation" />

            <Grid
              style={{ paddingTop: 15, paddingBottom: 15, width: "100%" }}
              container
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={9}>
                 <FormControl size="small" style={{ width: "250px" }}>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                      className="admin-order-tables-form-select"
                      label="Company"
                      onChange={handleStatusBoxChange}
                      value={statusBox}
                    >
                      <MenuItem value={-1}>All</MenuItem>
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                  </FormControl>
              </Grid>
              <Grid item xs={3}>
                <div className="right-header" >
                  <TextField
                    className="admin-order-tables-form-textfield"
                    placeholder="Search"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={search_value}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {      
                        setQuery(e.target.value);
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setSearchValue('')
                            setQuery("")}}
                        >
                          <CancelRoundedIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={12}>
                <DataGridPro
                  title="Discounts"
                  hideFooter
                  initialState={{
                    hideFooterPagination: true,
                  }}
                  autoPageSize
                  rowHeight={40}
                  style={{ width: "100%", padding: "10px", height: "1000px" }}
                  columnHeaderHeight={35}
                  rows={data}
                  columns={columns}
                  sx={{
                    '& .MuiDataGrid-columnHeaders': {
                      color: 'var(--color-primary-purple)'
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 700,
                    },
                  }}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  component="div"
                  count={totalRowCount}
                  rowsPerPage={currRowPerPage}
                  page={currPage}
                  onPageChange={handleChangeCurrPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Grid> */}
            </Grid>
          </Box>

          <Box sx={{ margin: 3 }}>
            <Grid container alignItems="flex-start" spacing={1}>
              <Grid item xs={6}></Grid>
            </Grid>
          </Box>
        </Box>
      </div>
      <br />
    </>
  );
};


export default function DiscountCoupons() {
  return <DiscountTable />;
}
